import { render, staticRenderFns } from "./moments_good_share.vue?vue&type=template&id=2b75eafb"
import script from "./moments_good_share.vue?vue&type=script&lang=js"
export * from "./moments_good_share.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports